import consts from 'services/metaData/consts';

/**
 * Prepares the container for being able to render the overlay vue component inside it
 *
 * @param container
 * @returns {{vueContainer: HTMLDivElement}}
 */
export const prepareContainer = (container = document.body) => {
    const vueContainer = document.createElement('div');
    const element = document.createElement('div');
    vueContainer.appendChild(element);
    container.appendChild(vueContainer);

    return {
        vueContainer
    };
};

let counter = 0;
export const generateId = () => {
    counter += 1;

    return counter;
};

export const iconMap = {
    general: {
        name: 'bullhornIcon',
        color: consts.COLORS_V2.PRIMARY_500,
        width: 21,
        height: 21
    },
    error: {
        name: 'warningNoteIcon',
        color: consts.COLORS_V2.NEGATIVE_500,
        width: 8,
        height: 21
    },
    success: {
        name: 'checkV2Icon',
        color: consts.COLORS_V2.SECONDARY_500,
        width: 21,
        height: 21
    },
    warning: {
        name: 'warningNoteIcon',
        color: consts.COLORS_V2.NEUTRAL_500,
        width: 8,
        height: 21
    },
    delete: {
        name: 'deleteV2Icon',
        color: consts.COLORS_V2.NEGATIVE_500,
        width: 21,
        height: 21
    }
};
